<div class="header" data-automation-e2e-selector="cardHeader">
  <i
    class="fa fa-times close-button"
    *ngIf="showCloseButton"
    (click)="onCloseClick($event)"
    data-icon
    data-automation-e2e-selector="closeTrancheDetailsButton"
  ></i>

  <muni-gameday-card-header
    [maturities]="maturities"
    [isOrderPeriodTerminated]="isOrderPeriodTerminated | async"
    [entity]="entity | async"
    [orderCount]="orderCount"
    [amount]="amount"
    [isLinkClickable]="isLinkClickable | async"
    data-automation-e2e-selector="trancheCardHeader"
  >
  </muni-gameday-card-header>
</div>
<div class="trancheDetails">
  <div class="trancheSummary">
    <muni-gameday-tranche-summary
      [tranche]="filteredTranche | async"
      [viewType]="viewType"
      data-automation-e2e-selector="trancheDetailsCard"
    >
    </muni-gameday-tranche-summary>
  </div>
  <div class="trancheOrders">
    <muni-gameday-tranche-orders-table
      [tranche]="filteredTranche | async"
      data-automation-e2e-selector="trancheOrderTable"
    >
    </muni-gameday-tranche-orders-table>
  </div>
</div>
